import { devhubMakeStyles } from '@devxdiscover/devhub-ui';

import { DevHubTypography } from '@devxdiscover/devhub-ui/dist/components/custom/DevHubTypography';

/**
 * ExplanationModalHeading
 * @returns Heading to be rendered in Explanation Modal
 */
function ExplanationModalHeading() {
  const classes = devhubMakeStyles({
    headingText: {
      color: '#3ea436',
    },
  })();
  return (
    <DevHubTypography fontSize="large" className={classes.headingText}>
      What is the Green Score?
    </DevHubTypography>
  );
}

export default ExplanationModalHeading;
